import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Icon } from '../stories/Icon';
import { ReservationWidget } from './ReservationWidget';

interface FullScreenModalReservationProps {
  show: boolean;
  onClose: () => void;
}

export const FullScreenModalReservation: React.FC<FullScreenModalReservationProps> = ({
  show,
  onClose,
}) => {
  const __ = useTranslation().t;

  const CloseButton = () => {
    return <StyledIcon name="arrow-left" onClick={onClose} />;
  };

  return (
    <Modal show={show} fullscreen onHide={onClose} style={{ top: 70, height: 'calc(100% - 70px)' }}>
      <Modal.Header className="align-items-center">
        <CloseButton />
        <StyledH2>{__('bookLiveClass')}</StyledH2>
        <div />
      </Modal.Header>
      <Modal.Body>
        <ReservationWidget />
      </Modal.Body>
    </Modal>
  );
};

const StyledH2 = styled.h2`
  font-family: 'Baloo 2';
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #444444;
  flex: 1;
  text-align: center;
`;

const StyledIcon = styled(Icon)`
  font-size: 20px;
  cursor: pointer;
`;
